<template>
  <div class="doc-block">
    <img class="doc-block__image" :src="mediaUrl" />
  </div>
</template>

<script>
export default {
  name: "DocBlock",
  props: {
    mediaUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.doc-block {
  background-color: $color-grey-light;
  padding: 20px;
  text-align: center;
  margin-bottom: 10px;

  @include respond-above(md) {
    background-color: $color-white;
  }

  &__image {
    max-width: 100%;
  }
}
</style>
